export enum PayErrors {
  NOT_FOUND_BY_PHONE = -320009,
  NOT_FOUND_BY_LOAN = -320100,
  SMS_LIMIT = -320018,
  TO_MUCH_AMOUNT = 'to_much_amount',
  TO_MUCH_AMOUNT_LOAN = 'to_much_amount_loan',
}

export * from './ToMuchAmountError';
export * from './SmsLimitError';
export * from './NotFoundError';
export * from './WrongCodeError';
